import { client } from '../axios';
import type { AxiosProgressEvent } from 'axios';
import { ResponseError } from '@/types';
import { resolveError } from '@/data/_resolveError';
import { UserProfilePrice } from '@/types/PriceType';

export const fetchPrices = (
    success = (items: UserProfilePrice[]) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/profile/prices`)
        .then(({ data }: any) => success(data.data))
        .catch((error) => resolveError(error, failed));
};

export const createPrice = (
    payload: Pick<UserProfilePrice, 'title' | 'description' | 'price' | 'currency'>,
    success = (item: UserProfilePrice) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/prices`, payload)
        .then(({ data }: any) => success(data.data))
        .catch((error) => resolveError(error, failed));
};

export const updatePrice = (
    id: string,
    payload: Pick<UserProfilePrice, 'title' | 'description' | 'price' | 'currency'>,
    success = (item: UserProfilePrice) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/prices/${id}`, payload)
        .then(({ data }: any) => success(data.data))
        .catch((error) => resolveError(error, failed));
};

export const deletePrice = (
    id: string,
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/prices/${id}/delete`)
        .then(({ data }: any) => success())
        .catch((error) => resolveError(error, failed));
};

export const sortPrices = (
    items: UserProfilePrice[],
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const sorted = items.map((i) => i.id);
    client.post(`/profile/prices/sort`, { sorted })
        .then(({ data }: any) => success())
        .catch((error) => resolveError(error, failed));
};

export const uploadPriceCover = async (
    id: string,
    file: File,
    success = (item: UserProfilePrice) => {},
    failed = (type: ResponseError, data: any) => {},
    onProgress?: (percent: number) => void
) => {
    const formData = new FormData();
    formData.append('file', file);
    await client.post(`/profile/prices/${id}/cover`, formData, {
        onUploadProgress: (e: AxiosProgressEvent) => {
            if (!onProgress || !e.total) return;
            const percent = Math.round((e.loaded * 100) / e.total);
            onProgress(percent);
        },
    })
        .then(({ data }: any) => success(data.data))
        .catch((error) => resolveError(error, failed));
};

export const deletePriceCover = (
    id: string,
    success = (item: UserProfilePrice) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/prices/${id}/cover/delete`)
        .then(({ data }: any) => success(data.data))
        .catch((error) => resolveError(error, failed));
};


